const config = {
    companyName: "Kander LC",
    companyEmail: "contact@kandertechnology.com"
  };
  
  export default config;